/* global wp */
import { connectHits } from 'instantsearch.js/es/connectors';

const renderProductCard = item => {
	const { __ } = wp.i18n;

	const newBadge = item.new
		? `<span class="grid items-center justify-center absolute top-0 right-0 size-16 ml-auto bg-[#1d1d1b] text-cream rounded-full text-lg uppercase">${__('New', 'swd')}</span>`
		: '';

	const imageBlock = item.image
		? `<img src="${item.image}" class="w-full max-w-44 h-44 mb-6 mx-auto object-contain" alt="${item.image_alt}">`
		: '';

	const categoryLabel =
		item.taxonomies.product_cat.length > 0 ? item.taxonomies.product_cat[0].replace(/-/g, ' ') : '';
	const catBlock = categoryLabel ? `<span class="text-xs o-mb20 c-text-btn">${categoryLabel}</span>` : '';

	return [
		`<a href="${item.url}" class="flex flex-col relative text-center c-product-card" data-label="${__('View', 'swd')}">`,
		newBadge,
		imageBlock,
		catBlock,
		`<h2 class="font-sans text-xl xs:text-2xl">${item.title}</h2>`,
		'</a>',
	].join('');
};

// create the render function
const renderHits = renderOptions => {
	const { hits, widgetParams } = renderOptions;

	if (hits.length === 0) return;

	widgetParams.container.innerHTML = hits.map(renderProductCard).join('');
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
